import { createNavigation } from 'next-intl/navigation';
import { routing } from './routing';

// Crear helpers de navegación tipados para static export
export const { Link, redirect, usePathname, useRouter } = createNavigation(routing);
